import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const Title = styled(Typography)`
  font-family: Calibre-Regular, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
`;
